(function () {

  // ─── Shared cart state ───────────────────────────────────────────
  let cartVariantIds = new Set();
  let isSyncing = false;

  function getCartSectionId() {
    return document.querySelector('cart-items-component[data-drawer]')?.dataset.sectionId || null;
  }

  // ─── Button states ───────────────────────────────────────────────
  function updateAllButtons() {
    document.querySelectorAll('.cart-cross-sell__add').forEach(btn => {
      // Don't touch buttons that are mid-loading
      if (btn.classList.contains('is-loading')) return;
      btn.classList.toggle('is-active', cartVariantIds.has(String(btn.dataset.variantId)));
    });
  }

  // ─── Sync cart state ─────────────────────────────────────────────
  async function syncCart() {
    if (isSyncing) return;
    isSyncing = true;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      cartVariantIds = new Set(cart.items.map(i => String(i.variant_id)));
      updateAllButtons();
    } catch (e) {
      console.error('Cart sync error:', e);
    } finally {
      isSyncing = false;
    }
  }

  // ─── Refresh cart drawer ─────────────────────────────────────────
  async function refreshCartDrawer(cart) {
    const sectionId = getCartSectionId();
    if (!sectionId) return;

    try {
      const sectionsData = await fetch(`${window.location.pathname}?sections=${sectionId}`)
        .then(r => r.json());

      const drawer = document.querySelector('cart-drawer-component');
      const hadAutoOpen = drawer?.hasAttribute('auto-open');
      if (hadAutoOpen) drawer.removeAttribute('auto-open');

      // Watch for DOM changes, restore button states the moment morph touches the cross-sell
      const crossSellList = document.querySelector('.cart-cross-sell__list');
      if (crossSellList) {
        const observer = new MutationObserver(() => {
          observer.disconnect();
          document.querySelectorAll('.cart-cross-sell__add').forEach(btn => {
            btn.classList.toggle('is-active', cartVariantIds.has(String(btn.dataset.variantId)));
            btn.classList.remove('is-loading');
          });
        });
        observer.observe(crossSellList, { childList: true, subtree: true, attributes: true });
      }

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'cart-cross-sell',
          data: {
            sections: sectionsData,
            itemCount: cart.item_count,
            source: 'cart-cross-sell'
          }
        }
      }));

      if (hadAutoOpen) drawer.setAttribute('auto-open', '');

    } catch (e) {
      console.error('Drawer refresh error:', e);
    }
  }

  // ─── Click handler ───────────────────────────────────────────────
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.cart-cross-sell__add');
    if (!btn || btn.disabled) return;

    const variantId = String(btn.dataset.variantId);
    const wasActive = btn.classList.contains('is-active');

    // Show fill loader, lock button
    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
      const response = await fetch(wasActive ? '/cart/change.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(wasActive
          ? { id: variantId, quantity: 0 }
          : { id: variantId, quantity: 1 }
        )
      });

      if (!response.ok) throw new Error('Cart request failed');

      const cart = await fetch('/cart.js').then(r => r.json());
      cartVariantIds = new Set(cart.items.map(i => String(i.variant_id)));

      // Remove loader, then swap icon in next frame
      btn.classList.remove('is-loading');
      btn.disabled = false;

      requestAnimationFrame(() => {
        btn.classList.toggle('is-active', !wasActive);
        updateAllButtons();
      });

      await refreshCartDrawer(cart);

    } catch (err) {
      console.error('Cart update error:', err);
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  });

  // ─── Sync when cart drawer opens ────────────────────────────────
  document.querySelector('cart-drawer-component')?.addEventListener('dialog:open', syncCart);

  // ─── External cart change listener ──────────────────────────────
  document.addEventListener('cart:update', (e) => {
    if (e.detail?.data?.source === 'cart-cross-sell') return;
    syncCart();
  });

})();